import React from 'react';
import Modal from '$/components/global/modal';
import './index.scss';
import BixButton from '$/components/global/bixButton';

export interface IDisclaimerProps {
  modalTitle: string;
  modalBody: string | null;
  modalAcceptButtonText: string;
  disclaimerAcknowledged: boolean;
  onCloseDisclaimer: () => void | Promise<void>;
  onAcknowledgeDisclaimer: () => void | Promise<void>;
  hideCloseButton?: boolean;
}

const Disclaimer: React.FC<IDisclaimerProps> = props => {
  const {
    disclaimerAcknowledged,
    modalTitle,
    modalBody,
    modalAcceptButtonText,
    onCloseDisclaimer,
    onAcknowledgeDisclaimer,
    hideCloseButton,
  } = props;

  const disclaimerModal = (
    <Modal title={modalTitle} active={true} onClose={onCloseDisclaimer} hideClose={hideCloseButton}>
      <p>{modalBody}</p>
      <div className="button_contain">
        <BixButton useSmall onClick={onAcknowledgeDisclaimer}>
          {modalAcceptButtonText}
        </BixButton>
      </div>
    </Modal>
  );

  return disclaimerAcknowledged ? null : disclaimerModal;
};

export default Disclaimer;
